import styled from '@emotion/styled'
import { space } from 'styled-system'
import { motion } from 'framer-motion'

const StyledCircularProgress = styled(motion.svg)<any>`
	${space}
`

const StyledCircle = styled.circle<any>`
	fill: none;
	stroke-linecap: round;
`

const StyledPath = styled(motion.path)<any>`
	fill: none;
	stroke-linecap: round;
`

export {
	StyledCircularProgress,
	StyledCircle,
	StyledPath
}
